import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { router } from '@/router';
import { useAuthStore } from '@/stores/authStore';

function App() {
  const syncFromFirebaseUser = useAuthStore((state) => state.syncFromFirebaseUser);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      void syncFromFirebaseUser(firebaseUser);
    });

    return () => unsubscribe();
  }, [syncFromFirebaseUser]);

  return <RouterProvider router={router} />;
}

export default App;

